module.exports = __webpack_public_path__ + "static/media/icon-contact.4d7a40be.png";